import { BackendApiRequest } from './client'

type ShowTermConsentResponse = {
  needConsentLatestTerm: boolean
  privacyPolicyUrl: string
  termUrl: string
}

export const checkTermConsent = async () => {
  return await BackendApiRequest<ShowTermConsentResponse>({
    url: `/v1/terms/consent`,
  })
}

export const postTermConsent = async () => {
  return await BackendApiRequest<void>({
    method: 'POST',
    url: `/v1/terms/consent`,
  })
}
